import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { cellHead, cellHead1, cellHead2 } from './gridPanel/tableHead';

function ProviderOtherInfo() {
  const providerDetailsData = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerDetailsData
  );
  const [preProvider, setPreProvider] = useState([]);
  const [providerStatus, setProviderStatus] = useState([]);
  const [providerTaxonomy, setProviderTaxonomy] = useState([]);

  useEffect(() => {
    if (providerDetailsData?.data) {
      if (providerDetailsData?.data?.prevProvider) {
        setPreProvider(providerDetailsData?.data?.prevProvider);
      }
      if (providerDetailsData?.data?.providerTaxonomy) {
        setProviderTaxonomy(providerDetailsData?.data?.providerTaxonomy);
      }
      if (providerDetailsData?.data?.providerStatus) {
        setProviderStatus(providerDetailsData?.data?.providerStatus);
      }
    }
  }, [providerDetailsData]);

  return (
    <div className='row mt-4'>
      <div className='col-md'>
        <fieldset className='custom-fieldset'>
          <legend className='same-font-family '>Provider Status</legend>
          <div className='sub-radio no-margin override-width-95'>
            <TableGridWithFeatures
              gridHeight={250}
              rowData={providerStatus || []}
              columnDefs={cellHead}
              enterMovesDown
              suppressCellFocus
              applyFilter={false}
              exportFile
              childPopup={false}
              helpMessage=''
              data-testid='onEditingStopped'
              fileName='Provider-Status'
            />
          </div>
        </fieldset>
      </div>
      <div className='col-md'>
        <fieldset className='custom-fieldset'>
          <legend className='same-font-family '>Previous Provider</legend>
          <div className='sub-radio no-margin override-width-95'>
            <TableGridWithFeatures
              gridHeight={250}
              rowData={preProvider || []}
              columnDefs={cellHead1}
              enterMovesDown
              suppressCellFocus
              applyFilter={false}
              exportFile
              childPopup={false}
              helpMessage=''
              data-testid='onEditingStopped'
              fileName='Provider-Status'
            />
          </div>
        </fieldset>
      </div>
      <div className='col-md'>
        <fieldset className='custom-fieldset'>
          <legend className='same-font-family '>Taxonomy</legend>
          <div className='sub-radio no-margin override-width-95'>
            <TableGridWithFeatures
              gridHeight={250}
              rowData={providerTaxonomy || []}
              columnDefs={cellHead2}
              enterMovesDown
              suppressCellFocus
              applyFilter={false}
              exportFile
              childPopup={false}
              helpMessage=''
              data-testid='onEditingStopped'
              fileName='Provider-Status'
            />
          </div>
        </fieldset>
      </div>
    </div>
  );
}

export default ProviderOtherInfo;
